export default "__VITE_PUBLIC_ASSET__e2960d1f__"